export const OPTION_ADD = 'OPTION_ADD';
export const OPTION_REMOVE = 'OPTION_REMOVE';
export const OPTION_UPDATE_LABEL = 'OPTION_UPDATE_LABEL';
export const OPTION_UPDATE_OTHER_ANSWER = 'OPTION_UPDATE_OTHER_ANSWER';
export const OPTION_SET_ACTIVE = 'OPTION_SET_ACTIVE';
export const OPTION_RESET_ACTIVE = 'OPTION_RESET_ACTIVE';



/** WEBPACK FOOTER **
 ** ./src/store/modules/option/types.js
 **/